import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Globe } from 'lucide-react';
import { LOCALES } from '@xdocs/i18n';
import { useI18n } from '../../i18n/LocaleProvider.js';
import { cn } from '../../lib/cn.js';
import styles from './LanguageSwitcher.module.css';
const LOCALE_NAME_ID = {
    en: 'common:locale.name.en',
    ro: 'common:locale.name.ro',
};
/** Avatar-menu / Settings→Profile / landing header locale switcher
 * (CLAUDE_DESIGN.md §6, F0j). Live re-render on change — `LocaleProvider`
 * re-renders every consumer once the host app feeds the new `locale` prop back in. */
export function LanguageSwitcher({ onLocaleChange, className }) {
    const { t, locale } = useI18n();
    return (_jsxs("div", { className: cn(styles['wrapper'], className), role: "group", "aria-label": t('styleguide:localeToggle.label'), children: [_jsx(Globe, { size: 16, className: styles['icon'], "aria-hidden": "true" }), LOCALES.map((candidate) => (_jsx("button", { type: "button", "aria-pressed": candidate === locale, className: cn(styles['option'], candidate === locale && styles['active']), onClick: () => onLocaleChange(candidate), children: t(LOCALE_NAME_ID[candidate]) }, candidate)))] }));
}
